<template>
  <v-container>
    <h4 class="text-center mb-4">Zadaj dátum upratania</h4>
    <v-row justify="space-around">
      <v-date-picker
          @change="$emit('change', date)"
          :first-day-of-week="1"
          locale="sk-SK"
          v-model="date"
          color="primary lighten-1"
          header-color="accent darken-1"
          :min="today"/>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "ChooseDate",
    props: [
      'flatId'
    ],
     data () {
      return {
        date: new Date().toISOString().substr(0, 10),
        today: new Date().toISOString()
      }
    }
  }
</script>

